import trim from 'lodash/trim';
import IconEmoji from '@/assets/icons/emoji.svg';
import IconPhoto from '@/assets/icons/photo.svg';
import { Media } from '@/mixins/media';
import ChatDefs from '@/store/chat/chat.d';
import ChannelDefs from '@/store/channel/channel.d';
import { createNamespacedHelpers } from 'vuex';
import { Picker } from 'emoji-mart-vue-fast';
import { mixin as clickAway } from 'vue-clickaway';

const { mapActions: mapChatActions } = createNamespacedHelpers('Chat');
const {
  mapActions: mapChannelActions,
  mapMutations: mapChannelMutations,
  mapState: mapChannelState
} = createNamespacedHelpers('Channel');
const { mapState: mapConciergeState } = createNamespacedHelpers('Concierge');

export default {
  name: 'MessageInput',
  mixins: [Media, clickAway],
  components: {
    IconEmoji,
    IconPhoto,
    Picker
  },

  data: () => ({ message: '', showPicker: false, endTypingCallback: null }),

  computed: {
    ...mapConciergeState({
      currentConcierge: state => state.currentConcierge,

      isAllowedAccess: function(state) {
        return state.currentConcierge.conciergeLevel >= 199;
      }
    }),

    ...mapChannelState({
      currentChannel: state => state.currentChannel,

      lastMessageActivity: state => {
        const { last_message_activity } = state.currentChannel || {};
        return last_message_activity;
      },

      isOwned: function(state) {
        const { status, agentId } = state.currentChannel || {};
        return status === 'active' && agentId === this.currentConcierge.agentId;
      },

      isActive: function(state) {
        const { status } = state.currentChannel;
        return status === 'active';
      },

      isWaiting: function(state) {
        const { status } = state.currentChannel;
        return status === 'waiting';
      },

      isArchived: function(state) {
        const { status } = state.currentChannel;
        return status === 'archived';
      }
    })
  },

  methods: {
    ...mapChatActions({
      sendImage: ChatDefs.actions.sendImage,
      sendTextMessage: ChatDefs.actions.sendTextMessage,
      chatStore_UpdateCustomType: ChatDefs.actions.updateCustomType,
      chatStore_startTyping: ChatDefs.actions.startTyping,
      chatStore_endTyping: ChatDefs.actions.endTyping
    }),

    ...mapChannelActions({
      channelStore_PickChannel: ChannelDefs.actions.pickChannel
    }),

    ...mapChannelMutations({
      channelStore_SetCurrentChannelStatus:
        ChannelDefs.mutations.setCurrentChannelStatus
    }),

    pickChat: async function() {
      await this.chatStore_UpdateCustomType('active');
      await this.channelStore_PickChannel({
        channelUrl: this.currentChannel.channelUrl,
        conciergeId: this.currentConcierge.agentId
      });

      this.channelStore_SetCurrentChannelStatus('active');
      this.$emit('update:currentTab', 'own');
    },

    togglePicker: function() {
      this.showPicker = !this.showPicker;
    },

    closePicker: function() {
      this.showPicker = false;
    },

    addEmoji: function(emoji) {
      this.message += emoji.native;
    },

    /**
     * Handler when image icon is clicked
     * Upload image and send it to chat service
     */
    handleOnFileChange: async function(e) {
      const selectedFile = e.target.files[0];
      const uploadedImage = await this.uploadImage(selectedFile);
      await this.sendImage(uploadedImage);

      // TODO: handle image upload progress
      // TODO: handle on image upload error
    },

    /**
     * Handler when send button is clicked
     * Send the message to chat service
     */
    handleOnSendButtonClicked: function() {
      this.showPicker = false;
      // If message is empty, stop
      const trimmedMessage = trim(this.message);
      if (!trimmedMessage) return;
      this.sendTextMessage(trimmedMessage);
      this.message = '';
    },

    /**
     * FIXME: apply debouncing to avoid tons of event
     */
    handleOnInput: function() {
      if (this.endTypingCallback) {
        clearTimeout(this.endTypingCallback);
      }
      this.chatStore_startTyping();
      this.endTypingCallback = setTimeout(this.chatStore_endTyping, 5000);
    }
  }
};
